module.exports = __webpack_public_path__ + "media/backgrounds/gray-geometric-42c6e9ed.svg";